module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-386.672e12b.woff2";